export const scrollToHash = () => {
  if (window.location.hash === "") return;

  let retries = 0;
  const scroll = (id) => {
    if (retries > 50) return;
    retries += 1;
    const element = document.getElementById(id);
    if (element && document.readyState === "complete") {
      setImmediate(() => element.scrollIntoView());
    } else {
      setTimeout(() => scroll(id), 100);
    }
  };

  scroll(window.location.hash.replace("#", ""));
};
